import {
    IntentRequest,
    LaunchRequest,
    OptionSelectRequest,
    PermissionRequest
} from "stentor-models";
import { log } from "../utils";

export const TIMEOUT_FB_MS = 20000;
export const TIMEOUT_STENTOR_MS = 20000;

export type StentorRequest = IntentRequest | LaunchRequest | OptionSelectRequest | PermissionRequest;

/**
 * Sends a POST to your STENTOR based server.
 * 
 * @param data 
 * @param url 
 * @param key 
 * @param signal 
 * @returns 
 */
export async function postMessageToStentor<TResponse>(data: StentorRequest, url: string, key: string, signal?: AbortSignal): Promise<TResponse> {
    const body = JSON.stringify(data);

    log(`URL: ${url}`);
    log(`BODY: ${body}`);

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${key}`,
            "User-Agent": "Stentor Chat Server"
        },
        body,
        mode: "cors",
        signal
    });

    if (!response.ok) {
        throw new Error(`Status ${response.status}, Text: ${response.statusText}`);
    }

    return response.json();
}
